import React from 'react';
import Footer from 'components/organisms/footer';
import {
  AppBar, Toolbar, Box, Grid, Container,
} from '@mui/material';
import { Loader } from 'components/atoms';
import CoreErrorAlert from 'components/organisms/core-error-alert';
import { selectEnterprise } from 'base/core/selectors';
import { useSelector } from 'react-redux';
import { getUserHubUrl } from 'utils/common-utils';
import brokenImage from 'assets/images/broken-image.png';

export interface Props {
  children: React.ReactElement;
  loading?: boolean;
}
const GuestLayout = ({ children, loading }: Props) => {
  const { name, logo } = useSelector(selectEnterprise);
  const userHubUrl = getUserHubUrl();

  // const getStartBtnStyles = { ml: { md: '20px', lg: '35px', xl: '48px' } };
  const desktopNavStyles = { display: { xs: 'none', md: 'block' }, width: '100%' };
  const toolbarStylesDesktop = { minHeight: { md: '80px !important' } };
  const toolbarStylesMobile = { minHeight: { xs: '50px !important' } };
  const appBarStylesDesktop = { display: { xs: 'none', md: 'block' }, backgroundColor: 'background.paper', borderBottom: '1px solid #E7E7F1' };
  const appBarStylesMobile = { display: { xs: 'block', md: 'none' }, backgroundColor: 'background.paper', borderBottom: '1px solid #E7E7F1' };

  return (
    <Loader loading={loading ?? false}>
      <AppBar component="nav" position="sticky" sx={appBarStylesDesktop}>
        <Container fixed>
          <Toolbar disableGutters sx={toolbarStylesDesktop}>
            <Box sx={desktopNavStyles}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item md={2} lg={2} sx={{ textAlign: 'left' }}>
                  <a href={userHubUrl} rel="noreferrer">
                    <Box
                      component="img"
                      alt={name}
                      src={logo !== '' ? logo : brokenImage}
                      height={{ xs: 45, md: 55, display: 'block' }}
                      width="auto"
                    />
                  </a>
                </Grid>
              </Grid>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <AppBar component="nav" position="sticky" sx={appBarStylesMobile}>
        <Container fixed>
          <Toolbar disableGutters sx={toolbarStylesMobile}>
            <a href={userHubUrl} rel="noreferrer">
              <Box
                component="img"
                alt={name}
                src={logo !== '' ? logo : brokenImage}
                height={{ xs: 35, md: 55, display: 'block' }}
                width="auto"
              />
            </a>
          </Toolbar>
        </Container>
      </AppBar>
      <Container
        fixed
        sx={{
          py: {
            xs: '20px', sm: '35px', md: '35px', lg: '50px',
          },
        }}
        className="layout-container"
      >
        <CoreErrorAlert />
        {children}
      </Container>
      <Footer />
    </Loader>
  );
};

GuestLayout.defaultProps = {
  loading: false,
};

export default GuestLayout;
